export const PARTNER_CONSTS = {
    SET_PARTNERS_DATA:"SET_PARTNERS_DATA",
    GET_PARTNERS_BY_ID:"GET_PARTNERS_BY_ID",
    CREATE_PARTNER_ITEM:"CREATE_PARTNER_ITEM",
    UPDATE_PARTNER_ITEM: "UPDATE_PARTNER_ITEM",
    DELETE_PARTNER_ITEM: "DELETE_PARTNER_ITEM",
    UPDATE_PARTNERS_POSITIONS: "UPDATE_PARTNERS_POSITIONS",
};
